import React, { useContext } from "react";
import {
  Modal,
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { Stethoscope, UserRound, ClipboardList, ArrowLeft } from "lucide-react";
import { Context } from "../../../../Context/PermissoesContext";
import { useSnackbar } from "notistack";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(320px, 92vw)",
  bgcolor: "#fff",
  borderRadius: "18px",
  boxShadow: "0 16px 40px rgba(0, 0, 0, 0.16)",
  p: 2,
};

export default function MenuCadastros({ open, onClose }) {
  const history = useHistory();
  const { checarPermissaoComAcao, checarPermissao } = useContext(Context);
  const { enqueueSnackbar } = useSnackbar();

  const abrirTela = caminho => {
    checarPermissaoComAcao("AGC004", () => {
      onClose();
      history.push(caminho);
    });
  };

  const abrirPacientes = () => {
    if (!checarPermissao("GDC001")) {
      enqueueSnackbar("Erro! Você não tem permissão para acessar clientes.", {
        variant: "error",
      });
      return;
    }

    if (!checarPermissao("GDC002")) {
      enqueueSnackbar("Erro! Você não tem permissão para cadastrar cliente.", {
        variant: "error",
      });
      return;
    }

    onClose();
    history.push("/gestaoDeClientes");
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <List disablePadding>
          <ListItemButton sx={{ borderRadius: 2, mb: 0.5 }} onClick={() => abrirTela("/agendaCare/medicos")}>
            <ListItemIcon sx={{ minWidth: 36, color: "#0037FF" }}>
              <Stethoscope size={20} />
            </ListItemIcon>
            <ListItemText
              primary="Médicos"
              primaryTypographyProps={{ color: "#0037FF", fontWeight: 500 }}
            />
          </ListItemButton>

          <ListItemButton
            sx={{ borderRadius: 2, mb: 0.5 }}
            onClick={() => abrirTela("/agendaCare/enfermeiros")}
          >
            <ListItemIcon sx={{ minWidth: 36, color: "#0037FF" }}>
              <Stethoscope size={20} />
            </ListItemIcon>
            <ListItemText
              primary="Enfermeiros"
              primaryTypographyProps={{ color: "#0037FF", fontWeight: 500 }}
            />
          </ListItemButton>

          <ListItemButton sx={{ borderRadius: 2, mb: 0.5 }} onClick={abrirPacientes}>
            <ListItemIcon sx={{ minWidth: 36, color: "#0037FF" }}>
              <UserRound size={20} />
            </ListItemIcon>
            <ListItemText
              primary="Pacientes"
              primaryTypographyProps={{ color: "#0037FF", fontWeight: 500 }}
            />
          </ListItemButton>

          <ListItemButton
            sx={{ borderRadius: 2, mb: 0.5 }}
            onClick={() => abrirTela("/agendaCare/atendimentos")}
          >
            <ListItemIcon sx={{ minWidth: 36, color: "#0037FF" }}>
              <ClipboardList size={20} />
            </ListItemIcon>
            <ListItemText
              primary="Atendimentos"
              primaryTypographyProps={{ color: "#0037FF", fontWeight: 500 }}
            />
          </ListItemButton>

          <ListItemButton sx={{ borderRadius: 2, mt: 1 }} onClick={onClose}>
            <ListItemIcon sx={{ minWidth: 36, color: "#0037FF" }}>
              <ArrowLeft size={20} />
            </ListItemIcon>
            <ListItemText
              primary="Voltar"
              primaryTypographyProps={{ color: "#0037FF", fontWeight: 500 }}
            />
          </ListItemButton>
        </List>
      </Box>
    </Modal>
  );
}
